import React from 'react';

import MUIContainer, { ContainerProps as MUIContainerProps } from '@mui/material/Container';

export type ContainerProps = MUIContainerProps;

const Container: React.FC<MUIContainerProps> = (props) => {
  const { children, ...containerProps } = props;
  return <MUIContainer {...containerProps}>{children}</MUIContainer>;
};

export default Container;
